/// <reference path="../Controller.ts" />
/// <reference path="../../HTML/Navigation/Item.ts" />
namespace HA.Core.Controller.Navigation {
    import Item = HA.Core.HTML.Navigation.Item;

    export class NavigationItem extends Controller {
        /**
         * @param data
         */
        protected initialize(data: Map<any, any>) {
            super.initialize(data);
            const hdata = new Map(data);
            const me = this;
            hdata.set("-events", toMap({
                click: () => {
                    me.click();
                },
            }));
            hdata.delete("click");
            this.createTag(hdata);

        }

        protected createTag(data: any) {
            this.addToData("tag", new Item(data));
        }
    }
}
